export default __webpack_public_path__ + "static/media/wk3.b3986d78.jpg";